export enum ProgressionCoursesTypes {
  GET_PROGRESSION_REQUEST = '@progression/GET_PROGRESSION_REQUEST',
  GET_PROGRESSION_SUCCESS = '@progression/GET_PROGRESSION_SUCCESS',
  GET_PROGRESSION_FAILURE = '@progression/GET_PROGRESSION_FAILURE',
  PREVIOUS_CLASS_REQUEST = '@progression/PREVIOUS_CLASS_REQUEST',
  PREVIOUS_CLASS_SUCCESS = '@progression/PREVIOUS_CLASS_SUCCESS',
  PREVIOUS_CLASS_FAILURE = '@progression/PREVIOUS_CLASS_FAILURE',
  CURRENT_CLASS_STATUS_REQUEST = '@progression/CURRENT_CLASS_STATUS_REQUEST',
  CURRENT_CLASS_STATUS_SUCCESS = '@progression/CURRENT_CLASS_STATUS_SUCCESS',
  CURRENT_CLASS_STATUS_FAILURE = '@progression/CURRENT_CLASS_STATUS_FAILURE',
  TOTAL_COMPLETED_REQUEST = '@progression/TOTAL_COMPLETED_REQUEST',
  TOTAL_COMPLETED_SUCCESS = '@progression/TOTAL_COMPLETED_SUCCESS',
  TOTAL_COMPLETED_FAILURE = '@progression/TOTAL_COMPLETED_FAILURE',
  LAST_CLASS = '@progression/LAST_CLASS',
}

export interface LastLessonTypes {
  created_at: number;
  id: number;
  nome: string;
  status_id: boolean;
  updated_at: string;
  order: number;
  topic_id: number;
  url_video: string;
  ordem: number;
  free: boolean;
}

export interface ProgressionCourseTypes {
  progression: number;
  total_aula: number;
  last_lasson: {
    created_at: number;
    id: number;
    nome: string;
    status_id: boolean;
    updated_at: string;
    order: number;
    topic_id: number;
    url_video: string;
    ordem: number;
    free: boolean;
  };
  next: Array<LastLessonTypes>;
  previous: Array<LastLessonTypes>;
  concluded: boolean;
  total_completed: any;
}

export interface RequestState {
  get_progression_course: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  previous_Class: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  class_current_status: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  count_topics: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
}

export interface ProgressionCourseState {
  progression_course: ProgressionCourseTypes;
  readonly request: RequestState;
}
